import React from "react";

const MapSection = ({ height = "450px" }) => {
  return (
    <section
      className="mrv-contact-map"
      style={{ height: height }}
    >
      <iframe
        src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3502.9069411596797!2d77.03282554240445!3d28.602568422949986!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x390d1acb978e6a67%3A0x3b17ac85178477b7!2sMrv%20School%2C%20Sector%2013%2C%20Dwarka%2C%20Delhi%2C%20110078!5e0!3m2!1sen!2sin!4v1770372953875!5m2!1sen!2sin"
        width="100%"
        height="100%"
        style={{ border: 0 }}
        allowFullScreen=""
        loading="lazy"
        title="MRV School Location"
      ></iframe>
    </section>
  );
};

export default MapSection;
